app.service('regionSVG', function() {
	var params = {
		objName: 'mapProvincesPL',
		container: '#map-find-shop',
		idleColor: '#94b9f5',
		selectColor: '#0E4194',
		hooverColor: '#4e8bee',
		tooltipFontColor: 'rgba(250, 250, 250, 1)',
		selectCb: function() {},
		hooverCb: function() {},
		selected: {},
		map_path: {},
	};
	var tooltip = {
		rect: {},
		text: {},
		hooverRect: {},
		hooverText: {}
	};

	// Fields

	// Functions
	function hoover(e) {
		e.attr('fill', params.hooverColor);

		var pathBB = e[0].getBBox();
		var x = Math.floor(pathBB.x + pathBB.width / 2.0);
		var y = Math.floor(pathBB.y + pathBB.height / 2.0);
		tooltip.hooverText.text($(e).attr('data-name'));
		var txtBB = tooltip.hooverText[0].getBBox();
		tooltip.hooverRect
			.attr('x', -7.5 + x - txtBB.width * 0.5)
			.attr('y', -17 + y - txtBB.height * 0.5)
			.attr('width', txtBB.width + 15)
			.attr('height', txtBB.height + 15)
			.css('fill', params.hooverColor);
		tooltip.hooverText
			.attr('x', x)
			.attr('y', y)
			.attr('fill', params.tooltipFontColor);

		tooltip.hooverRect.attr('visibility', 'visible');
		tooltip.hooverText.attr('visibility', 'visible');
		params.hooverCb(e);
	}

	function select(e, action) {
		if (!$(e).is(params.selected)) {
			relax(params.selected[0]);
		} else {
			return 0;
		}
		params.selected = e;

		e.attr('fill', params.selectColor);
		var pathBB = e[0].getBBox();
		var x = Math.floor(pathBB.x + pathBB.width / 2.0);
		var y = Math.floor(pathBB.y + pathBB.height / 2.0);
		tooltip.text.text($(e).attr('data-name'));
		var txtBB = tooltip.text[0].getBBox();
		tooltip.rect
			.attr('x', -7.5 + x - txtBB.width * 0.5)
			.attr('y', -17 + y - txtBB.height * 0.5)
			.attr('width', txtBB.width + 15)
			.attr('height', txtBB.height + 15)
			.css('fill', params.selectColor);
		tooltip.text
			.attr('x', x)
			.attr('y', y)
			.css('fill', params.tooltipFontColor);

		tooltip.hooverRect.attr('visibility', 'hidden');
		tooltip.hooverText.attr('visibility', 'hidden');

		tooltip.rect.attr('visibility', 'visible');
		tooltip.text.attr('visibility', 'visible');
		if (action) {
			params.selectCb(e);
		}
	}

	function relax(e) {
		$(e).attr('fill', params.idleColor);
		tooltip.hooverRect.attr('visibility', 'hidden');
		tooltip.hooverText.attr('visibility', 'hidden');
	}

	function start(config) {
		$.extend(params, config);

		tooltip.rect = $('#map-tt-rtg-lock');
		tooltip.rect.attr('fill', params.selectColor);

		tooltip.text = $('#map-tt-txt-lock');
		tooltip.text.attr('fill', params.tooltipFontColor);

		tooltip.hooverRect = $('#map-tt-rtg');
		tooltip.hooverRect.attr('fill', params.hooverColor);

		tooltip.hooverText = $('#map-tt-txt');
		tooltip.hooverText.attr('fill', params.tooltipFontColor);

		params.map_path = $('#map-find-shop path');
		params.map_path.attr('fill', params.idleColor);
		params.map_path.css('cursor', 'pointer');

		var self = this;

		params.map_path
			.mouseenter(function(e) {
				if (!$(this).is(params.selected)) {
					hoover($(this));
				}
			})
			.mouseout(function(e) {
				if (!$(this).is(params.selected)) {
					relax($(this));
				}
			})
			.click(function(e) {
				e.preventDefault();
				select($(this), true);
			});
		$(params.container).show();
	}

	function init(config) {
		start(config);
		//window[config.objName] = map;
	}


	return {
		select: function(region) {
			select($('path[data-code=' + region + ']'), false);
		},
		init: init
	};
});
